export default __webpack_public_path__ + "static/media/immaculateheartofmary.149d00f5.jpg";